type HubspotExternalReference = {
  externalSystem: 'hubspot'
  externalID: string | null
}

export function buildHubspotExternalReferences(
  hubspotDealId: string | null | undefined
): [HubspotExternalReference] | undefined {
  if (hubspotDealId === undefined) return undefined
  return [{ externalSystem: 'hubspot', externalID: hubspotDealId }]
}
